import { render, staticRenderFns } from "./Balances.vue?vue&type=template&id=70fe33fe&scoped=true"
import script from "./Balances.vue?vue&type=script&lang=ts&setup=true"
export * from "./Balances.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Balances.vue?vue&type=style&index=0&id=70fe33fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fe33fe",
  null
  
)

export default component.exports